<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>組織管理</template>
      <template v-slot:annotation>
        Hitonobiを使用しているお客様の一覧を表示します。情報を編集する場合は、データをクリックして操作を行ってください。
      </template>
    </PageHeader>

    <v-row class="text-center px-3">
      <v-col cols="12" md="4">
        <FormInputComponent label="組織名" v-model="searchKey" :length="10" />
      </v-col>
      <v-col cols="6" md="4" lg="2">
        <Button @click="get_organizations()" color="primary">検索</Button>
      </v-col>
      <v-col cols="6" md="4" lg="2">
        <Button @click="onClickOrganizationEditOpen(null)" color="info"
          >新規追加</Button
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          @click:row="onClickOrganizationEditOpen"
          :loading="loading"
          loading-text="読み込み中..."
        >
          <template v-slot:[`item.ORGANIZATION_NAME`]="{ item }">
            {{ item.ORGANIZATION_NAME }} ({{ item.ORGANIZATION_KEY }})
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <DialogMessage ref="dialog" />
    <OrganizationEdit
      ref="edit"
      @edit="editOrganizationInfo"
      @delete="deleteOrganizationInfo"
    />
  </v-container>
</template>

<script>
import axios from 'axios';
import config from '../../const.js';
import message from '../../message.js';
import OrganizationEdit from '@/components/pages/System/OrganizationEditDialog.vue';
import { getSessionStorageItem, makeDateFormatStr } from '../../common.js';
export default {
  components: {
    OrganizationEdit,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: '組織管理',
          route: 'OwnerTop',
        },
      ],

      // 変数宣言
      showContent: false,
      loading: false,
      searchKey: '',
      confirm: false,
      deleteOrganizationKey: config.EMPTY_STRING,

      // パラメータ取得
      organizationName: '',
      loginName: '',
      dispPosition: '',
      sessionId: '',
      // 自分自身のプラスの氣取得
      items: [],

      headers: [
        {
          text: '組織名',
          align: 'left',
          value: 'ORGANIZATION_NAME',
          width: '60%',
        },
        {
          text: '運用開始日',
          align: 'left',
          value: 'START_OPERATING_DATE',
          width: '20%',
        },
        {
          text: '運用終了日',
          align: 'left',
          value: 'END_OPERATING_DATE',
          width: '20%',
        },
      ],
    };
  },
  created() {
    // 組織情報取得
    this.deleteOrganizationKey = config.EMPTY_STRING;
    this.get_organizations();
  },
  methods: {
    onClickOrganizationEditOpen(item) {
      // 組織情報編集画面を表示
      if (item == null) {
        this.$refs.edit.open(null, { color: 'red' });
      } else {
        this.deleteOrganizationKey = item.ORGANIZATION_KEY;
        this.$refs.edit.open(item, { color: 'red' });
      }
    },
    deleteOrganizationInfo() {
      // 組織情報取得
      this.get_organizations();
    },
    editOrganizationInfo() {
      // 組織情報取得
      this.deleteOrganizationKey = config.EMPTY_STRING;
      this.get_organizations();
    },
    async get_organizations() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;
      let vm = this;

      if (this.searchKey == null || !this.searchKey.trim()) {
        this.searchKey = config.EMPTY_STRING;
      }

      await axios
        .get(
          config.CONNECT_OWNER_URL +
            '/Owner/organizations/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.searchKey +
            '/' +
            this.deleteOrganizationKey
        )
        .then((response) => {
          // 組織データ取得
          vm.items = response.data;

          // 組織情報データ編集
          for (var i = 0; i < vm.items.length; i++) {
            // 運用開始日
            if (
              vm.items[i].START_OPERATING_DATE != null &&
              vm.items[i].START_OPERATING_DATE.trim()
            ) {
              vm.items[i].START_OPERATING_DATE = makeDateFormatStr(
                vm.items[i].START_OPERATING_DATE,
                '/',
                '/',
                ''
              );
            }
            // 運用終了日
            if (
              vm.items[i].END_OPERATING_DATE != null &&
              vm.items[i].END_OPERATING_DATE.trim()
            ) {
              if (vm.items[i].END_OPERATING_DATE == config.END_OPERATING_DATE) {
                vm.items[i].END_OPERATING_DATE = config.END_OPERATING_DATE_PLAY;
              } else {
                vm.items[i].END_OPERATING_DATE = makeDateFormatStr(
                  vm.items[i].END_OPERATING_DATE,
                  '/',
                  '/',
                  ''
                );
              }
            }
          }
          // 検索文字調整
          if (this.searchKey == config.EMPTY_STRING) {
            this.searchKey = '';
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 404) {
            this.searchKey = '';
            errStr = message.MSG_INFO_SEARCH_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
  },
};
</script>
